'use es6';

import { Route, Switch, Redirect } from 'react-router-dom';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import HubspotApp from './components/legacyLogins/app/HubspotApp';
import LoginLandingContainer from './components/legacyLogins/v1/LoginLandingContainer';
import GoogleLoginConfirmationLanding from './components/GoogleLoginConfirmation/GoogleLoginConfirmationLanding';
import { LoginConfirmationLandingAndRedirect } from './components/LoginConfirmation/LoginConfirmationLandingAndRedirect';
import OneTimePasswordComponent from './components/OneTimePassword';
import EmptyLandingPageComponent from './components/OneTimePassword/EmptyLandingPage';
import AsyncComponentLoading from './components/AsyncComponentLoading';
import InternalLoginCookies from './components/InternalLoginCookies';
import AsyncComponentErrorHandler from './utils/AsyncComponentErrorHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfirmToLoginPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/ConfirmToLogin/ConfirmToLoginPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const LoginLinkInfoPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/ConfirmToLogin/LoginLinkInfoPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const VettingPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/VettingPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TrustTokenPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/TrustTokenPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const NotFoundLanding = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/NotFoundLanding').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasswordResetPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/PasswordReset/deprecated/PasswordResetPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const RequestResetEmailPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/RequestResetEmail/RequestResetEmailPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SsoAcsPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/SsoLogin/SsoAcsPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SsoCompletionPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/SsoLogin/SsoCompletionPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SsoLoginPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-Extra" */'./components/SsoLogin/SsoLoginPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-Extra')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorAuthPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactor" */'./components/TwoFactorAuth/TwoFactorAuthPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoveryPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactor" */'./components/TwoFactorRequestRecovery/deprecated/TwoFactorRecoveryPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoveryAdminPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactor" */'./components/TwoFactorRequestRecovery/deprecated/TwoFactorRecoveryAdminPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRecoveryVerifyPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactor" */'./components/TwoFactorRecoveryVerify/TwoFactorRecoveryVerifyPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const SmartLoginPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactor" */'./components/legacyLogins/v3/SmartLoginLandingPage').catch(AsyncComponentErrorHandler('chunk-TwoFactor')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
export const LegacyRoutes = ({
  location,
  isMobileLogin
}) => /*#__PURE__*/_jsx(HubspotApp, {
  location: location,
  isMobileLogin: isMobileLogin,
  children: /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/",
      route: {
        name: 'login'
      },
      render: props => /*#__PURE__*/_jsx(SmartLoginPage, Object.assign({}, props, {
        route: {
          name: 'login-beta'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/beta",
      route: {
        name: 'login'
      },
      render: props => /*#__PURE__*/_jsx(Redirect, Object.assign({
        replace: true,
        to: `/${location.search}${location.hash}`
      }, props))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/legacy",
      route: {
        name: 'legacy login'
      },
      render: props => /*#__PURE__*/_jsx(LoginLandingContainer, Object.assign({}, props, {
        route: {
          name: 'login'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/chatspot",
      route: {
        name: 'login-chatspot'
      },
      render: props => /*#__PURE__*/_jsx(SmartLoginPage, Object.assign({}, props, {
        route: {
          name: 'login-chatspot'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/connect",
      route: {
        name: 'login-connect'
      },
      render: props => /*#__PURE__*/_jsx(SmartLoginPage, Object.assign({}, props, {
        route: {
          name: 'login-connect'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/sso",
      render: props => /*#__PURE__*/_jsx(SsoLoginPage, Object.assign({}, props, {
        route: {
          name: 'sso-login'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/sso/acs",
      render: props => /*#__PURE__*/_jsx(SsoAcsPage, Object.assign({}, props, {
        route: {
          name: 'sso-acs'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/sso/complete",
      render: props => /*#__PURE__*/_jsx(SsoCompletionPage, Object.assign({}, props, {
        route: {
          name: 'sso-complete'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/forgot",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "forgot",
        route: {
          name: 'forgot'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/password-leak",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "passwordLeak",
        route: {
          name: 'password-leak'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/suspicious-activity",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "suspiciousActivity",
        route: {
          name: 'suspicious-activity'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/anomalous-login",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "anomalousLogin",
        route: {
          name: 'anomalous-login'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/idle-user",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "idleUser",
        route: {
          name: 'idle-user'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/beta/idle-user",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "idleUser",
        route: {
          name: 'idle-user'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/update-password",
      render: props => /*#__PURE__*/_jsx(RequestResetEmailPage, Object.assign({}, props, {
        updateType: "updatePassword",
        route: {
          name: 'updatePassword'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/two-factor",
      render: props => /*#__PURE__*/_jsx(TwoFactorAuthPage, Object.assign({}, props, {
        route: {
          name: 'twoFactorAuth'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/two-factor/recovery",
      render: props => /*#__PURE__*/_jsx(TwoFactorRecoveryPage, Object.assign({}, props, {
        route: {
          name: 'twoFactorRecovery'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/two-factor/admin-recovery",
      render: props => /*#__PURE__*/_jsx(TwoFactorRecoveryAdminPage, Object.assign({}, props, {
        route: {
          name: 'twoFactorRecoveryAdmin'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/two-factor/recovery-verify",
      render: props => /*#__PURE__*/_jsx(TwoFactorRecoveryVerifyPage, Object.assign({}, props, {
        route: {
          name: 'twoFactorRecoveryConfirmation'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/confirm-to-login",
      render: props => /*#__PURE__*/_jsx(ConfirmToLoginPage, Object.assign({}, props, {
        route: {
          name: 'confirmToLogin'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/passwordReset",
      render: props => /*#__PURE__*/_jsx(PasswordResetPage, Object.assign({}, props, {
        route: {
          name: 'passwordReset'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/googleLoginRedirect",
      render: props => /*#__PURE__*/_jsx(GoogleLoginConfirmationLanding, Object.assign({}, props, {
        route: {
          name: 'googleRedirect'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/googleLoginLoopback",
      render: props => /*#__PURE__*/_jsx(LoginConfirmationLandingAndRedirect, Object.assign({}, props, {
        loginType: "GOOGLE",
        route: {
          name: 'googleLoopbackRedirect'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/microsoftLoginRedirect",
      render: props => /*#__PURE__*/_jsx(LoginConfirmationLandingAndRedirect, Object.assign({}, props, {
        loginType: "MICROSOFT",
        route: {
          name: 'microsoftRedirect'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/appleLoginRedirect",
      render: props => /*#__PURE__*/_jsx(LoginConfirmationLandingAndRedirect, Object.assign({}, props, {
        loginType: "APPLE",
        route: {
          name: 'appleRedirect'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/trust-token",
      render: props => /*#__PURE__*/_jsx(TrustTokenPage, Object.assign({}, props, {
        route: {
          name: 'trustToken'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/otp",
      render: props => /*#__PURE__*/_jsx(OneTimePasswordComponent, Object.assign({}, props, {
        route: {
          name: 'otp'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/otpLandingPage",
      render: props => /*#__PURE__*/_jsx(EmptyLandingPageComponent, Object.assign({}, props, {
        route: {
          name: 'otpLandingPage'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/vetting",
      render: props => /*#__PURE__*/_jsx(VettingPage, Object.assign({}, props, {
        route: {
          name: 'vetting'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/internal-app",
      route: {
        name: 'internal'
      },
      render: props => /*#__PURE__*/_jsx(InternalLoginCookies, Object.assign({}, props, {
        route: {
          name: 'internal'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/confirm-to-login/login-link",
      render: props => /*#__PURE__*/_jsx(LoginLinkInfoPage, Object.assign({}, props, {
        route: {
          name: 'loginLink'
        }
      }))
    }), /*#__PURE__*/_jsx(Route, {
      render: props => /*#__PURE__*/_jsx(NotFoundLanding, Object.assign({}, props, {
        route: {
          name: 'notFound'
        }
      }))
    })]
  })
});